var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, Optional, H3, H2, Copy } from '@honda-canada/design-system-react';
import themeStyles from './TimelineSharedUI.styles';
import { stripMarkdownHeading, styledCompiler } from '../../../utils/markdown';
import CTA from '../../CTA';
var Content = themeStyles.apply(Box, 'Content');
var ContentTitle = themeStyles.apply(H3, 'ContentTitle');
var ContentSubTitle = themeStyles.apply(H2, 'ContentSubTitle');
var ContentCategory = themeStyles.apply(Copy, 'ContentCategory');
var ContentBody = themeStyles.apply(Copy, 'ContentBody');
var CTALink = themeStyles.apply(CTA, 'CTALink');
var Play = themeStyles.apply(Box, 'Play');
var TimelineTextContent = function (_a) {
    var _b, _c, _d, _e;
    var category = _a.category, subTitle = _a.subTitle, title = _a.title, bodyText = _a.bodyText, cta = _a.cta, textContentAlignment = _a.textContentAlignment;
    return (React.createElement(Content, null,
        React.createElement(Optional, { when: title },
            React.createElement(ContentTitle, { "data-testid": "cy-text-content-title", textContentAlignment: textContentAlignment }, styledCompiler(stripMarkdownHeading(title)))),
        React.createElement(Optional, { when: category },
            React.createElement(ContentCategory, { "data-testid": "cy-text-content-category", textContentAlignment: textContentAlignment }, styledCompiler(stripMarkdownHeading(category)))),
        React.createElement(Optional, { when: subTitle },
            React.createElement(ContentSubTitle, { "data-testid": "cy-text-content-subtitle", textContentAlignment: textContentAlignment }, styledCompiler(stripMarkdownHeading(subTitle)))),
        React.createElement(Optional, { when: bodyText },
            React.createElement(ContentBody, { "data-testid": "cy-text-content-body-text", textContentAlignment: textContentAlignment }, styledCompiler(stripMarkdownHeading(bodyText)))),
        React.createElement(Optional, { when: (_c = (_b = cta === null || cta === void 0 ? void 0 : cta.linkField) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.text },
            React.createElement(CTALink, __assign({}, cta, { typeField: { value: 'SecondaryDark' }, textContentAlignment: textContentAlignment }), (_e = (_d = cta === null || cta === void 0 ? void 0 : cta.linkField) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 :
                _e.text,
                React.createElement(Play, null)))));
};
export default TimelineTextContent;
